<template lang="pug">
  .progress-step.xs-f-xxsmall.max-at-tweak(v-if="true || progressStep" :class="{ 'services-redesign': isInServicesMenuExperiment }")
    .progress-line(v-if="!hideProgressLine")
      StepCircle(
        @click="handleClick('/colorbar/locations','locations', true)"
        :state-class="stepData.locationStep.stateClass"
        number="1"
        title="LOCATION"
        :hide-line="true"
        :show-info="showDesktopInfo"
        :disabled="editingAppointment"
      )
        span {{ locationText }}
      StepCircle(
        @click="handleClick('services', 'services')"
        :state-class="stepData['booking-services'].stateClass"
        number="2"
        title="SERVICE"
        :show-info="showDesktopInfo"
        :disabled="disableServiceStep"
      )
        span(v-if="serviceInfo") {{ serviceInfo }}
        div(v-if="serviceInfo && servicePrice")
          span.old-price(v-if="servicePrice.old" :class="{strike: hasDiscount}") (${{ servicePrice.old }})
          span(v-if="servicePrice.new") (${{ servicePrice.new }})

      StepCircle(
        @click="handleClick('calendar', 'calendar')"
        :state-class="stepData['booking-calendar'].stateClass"
        number="3"
        :title="dateTimeTitle"
        :show-info="showDesktopInfo"
        :disabled="editingAppointment"
      )
        span {{ selectedDateTime }}

      StepCircle(
        @click="handleClick('info', 'information')"
        v-if="showInfoStep"
        :state-class="stepData['booking-info'].stateClass"
        number="4"
        :title="infoTitle"
        :disabled="editingAppointment"
      )

      StepCircle(
        @click="handleClick('review')"
        :state-class="stepData['booking-confirmation'].stateClass"
        :number="reviewNumber"
        title="REVIEW"
        :disabled="editingAppointment"
      )

    .mobile-info.mt-100m(v-if="!hideProgressLine && showMobileInfo")
      .info-line.mb-100m.xs-f-xsmall(v-if="location")
        span {{ locationText }}
        a.underline(v-if="!editingAppointment" @click="handleClick('/colorbar/locations','locations', true)") Edit

      .info-line.mb-100m.xs-f-xsmall(v-if="serviceInfo")
        .info-line-price
          span {{ serviceInfo }}
          div(v-if="serviceInfo && servicePrice")
            span.ml-100m(v-if="servicePrice.old" :class="{strike: hasDiscount}") (${{ servicePrice.old }})
            span.ml-50m(v-if="servicePrice.new") (${{ servicePrice.new }})
        a.underline(v-if="!disableServiceStep" @click="handleClick('services','services')") Edit

      .info-line.mb-100m.xs-f-xsmall(v-if="selectedDateTime")
        span {{ selectedDateTime }}
        a.underline(v-if="!editingAppointment" @click="handleClick('calendar','calendar')") Edit

</template>
<script>
  import dayjs from '@dayjs';
  import { mapGetters, mapState } from 'vuex';
  import { getDateFromCalDate } from '../utils';
  import StepCircle from './StepCircle';

  const STEPS = ['locationStep', 'booking-services', 'booking-calendar', 'booking-info', 'booking-confirmation'];

  function formatDate(date, format = "ddd, MMM D, YYYY") {
    if (!date) {
      return;
    }
    const formatted = getDateFromCalDate(date.calDate);
    return dayjs(formatted).format(format);
  }

  export default {
    name: "ProgressStep",

    components: {
      StepCircle
    },

    inject: ['getObjProperty'],

    data() {
      return {
        stepData: {
          locationStep: {
            number: 1,
            stateClass: 'active'
          },
          'booking-services': {
            number: 2,
            stateClass: ''
          },
          'booking-calendar': {
            number: 3,
            stateClass: ''
          },
          'booking-info': {
            number: 4,
            stateClass: ''
          },
          'booking-confirmation': {
            number: 5,
            stateClass: ''
          },
        }
      };
    },

    computed: {
      ...mapState('global', [
        'windowData',
      ]),

      ...mapState('hairColorBarBooking', [
        'progressStep',
        'location',
        'selectedService',
        'selectedAddon',
        'selectedDate',
        'selectedTime',
        'editAppointment',
        'editingService',
      ]),

      ...mapState('customer', [
        'cdata',
      ]),

      ...mapGetters('hairColorBarBooking', ['subtotal', 'preDiscountSubTotal']),

      locationText() {
        const locationName = this.location && this.location.neighborhood;
        return locationName ? `${locationName} Color Bar` : '';
      },

      hideProgressLine() {
        return this.breakpoint === 'mobile' && this.progressStep === 'booking-calendar' && this.experiments['Booking Calendar Hide Steps'] === 'B';
      },

      showInfoStep() {
        return true;
      },

      disableServiceStep() {
        let disabled = false;

        if (this.editingAppointment) {
          disabled = !this.editingService;
        }

        return disabled;
      },

      editingAppointment() {
        return Boolean(this.editAppointment?._id);
      },

      showDesktopInfo() {
        return this.breakpoint !== 'mobile';
      },

      showMobileInfo() {
        return !this.showDesktopInfo && (this.location || this.serviceInfo || this.selectedDateTime);
      },

      breakpoint() {
        return this.windowData.breakpoint;
      },

      dateTimeTitle() {
        if (this.breakpoint === 'mobile') {
          return "DATE";
        } else {
          return "DATE & TIME";
        }
      },

      infoTitle() {
        if (this.breakpoint === 'mobile') {
          return "INFO";
        } else {
          return "CONTACT INFO";
        }
      },

      serviceInfo() {
        if (this.selectedService) {
          return this.selectedService.displayName || this.selectedService.name;
        } else {
          return '';
        }
      },

      servicePrice() {
        const isRootsService = !!this.selectedService && (this.getObjProperty(this, 'selectedService.code') || '').match('roots');
        const hidePrice = isRootsService && this.limitlessPro && !this.selectedDate;
        if (hidePrice) {
          return '';
        } else if (this.hasDiscount) {
          return {
            old: this.preDiscountSubTotal,
            new: this.subtotal
          };
        } else {
          return {
            old: this.preDiscountSubTotal
          };
        }
      },

      hasDiscount() {
        return this.preDiscountSubTotal != this.subtotal;
      },

      reviewNumber() {
        return this.showInfoStep ? '5' : '4';
      },

      selectedDateTime() {
        if (!this.selectedDate || !this.selectedTime) {
          return '';
        }
        const date = formatDate(this.selectedDate, "ddd, MMM D");
        return `${date}, ${this.selectedTime.time}`;
      },

      isInServicesMenuExperiment() {
        return this.experiments['Booking flow services redesign 2024'] == 'B';
      },

    },

    watch: {
      progressStep(newStep) {
        if (newStep) {
          let foundActive = false;
          for (let step of STEPS) {
            if (step !== newStep && !foundActive) {
              this.stepData[step].stateClass = 'done';
            } else if (step === newStep && !foundActive) {
              this.stepData[step].stateClass = 'active';
              foundActive = true;
            } else {
              this.stepData[step].stateClass = '';
            }
          }
        }
      }
    },

    methods: {
      handleClick(to, event, isUrl = false) {
        if (this.editAppointment && !this.editingService) {
          return;
        }

        if (event) {
          this.trackMREvent(`Booking flow - back to ${event} clicked`);
        }
        if (isUrl) {
          window.location = to;
        } else {
          const route = {
            name: `booking-${to}`,
            params: {
              code: this.location.code,
            },
          };
          this.$router.push(route);
        }
      }
    },
  };

</script>
<style scoped lang="stylus">
.progress-step
  margin 2.5em 0 1em 0
  border-radius 4px
  box-shadow 0px 2px 4px 0px rgba(119,119,119,0.1)
  background-color white
  padding 3em 1em 2em

  &.services-redesign
    margin 0 0 1em 0

  .mobile-info
    margin 1em 0em
    border-radius 4px
    box-shadow 0px 2px 4px 0px rgba(119,119,119,0.1)
    background-color white
    padding 2em 1em

    .info-line
      display flex
      justify-content space-between
      width 100%

      .info-line-price
        display flex

.progress-line
  display flex
  justify-content space-between
  align-items flex-start
  position relative

.old-price
  padding-right 5px

@media mq-mobile
  .progress-step
    background-color ui-color-3
    margin 0 0.25em
    padding 1em 0.5em

    &.services-redesign
      padding 0
      margin 0 0.25em

    .mobile-info
      margin 0

    .progress-line
      background-color #fff
      padding 1em 0

</style>